import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CandidateFeedbackModal from "./CandidateFeedbackModal";

import LocIcon from "../../assets/icons/locIcon.svg";
import TimeIcon from "../../assets/icons/timeicon.svg";
import BagIcon from "../../assets/icons/bagIcon.svg";
import PaperIcon from "../../assets/icons/paperIcon.svg";
import Logo from "../../assets/logo.svg";


function CandidateAppliedDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const job = location.state || {
    position: "UI/UX Designer",
    company: "Aiaura",
    category: "Design",
    location: "Remote",
    time: "Full-time",
    type: "On-site",
    level: "Mid-level",
    resumNum: 45,
  };
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <div className="flex gap-4 items-center">
          <img
            src={Logo}
            className="w-14 h-14 rounded-full"
            alt="Company Logo"
          />
          <div className="flex flex-col gap-1">
            <div className="flex gap-4 items-baseline ">
              <h1 className="text-gray-800 text-xl font-semibold ">
                {job.position}
              </h1>
              <span className="border border-blue-300 bg-blue-100 text-blue-500 font-semibold px-3 py-1 rounded-xl text-xs flex gap-1 items-center">
                <span> &bull; </span>
                {job.category}
              </span>
            </div>
            <div className=" ">
              <p className="text-gray-500 font-normal text-xs ">
                {job.company}
              </p>
            </div>
          </div>
        </div>
        <div className="flex gap-3">
          <button
            onClick={() => setShowFeedback(true)}
            className="text-[#19BFB7] border border-[#19BFB7] text-sm font-semibold rounded-lg px-4 py-2 bg-white cursor-pointer hover:bg-teal-50 transition duration-150"
          >
            Leave Feedback
          </button>
          <button className="text-red-600 border border-red-300 text-sm font-semibold rounded-lg px-4 py-2 bg-white cursor-pointer hover:bg-red-50 transition duration-150">
            Withdraw Application
          </button>
        </div>
      </div>

      <div className="flex items-center gap-4 pt-1">
        <p className="text-gray-500 font-semibold text-xs flex gap-2 items-center">
          <img src={TimeIcon} alt="time icon" className="w-4 h-4" />
          <span className="border-r border-gray-400 pr-2">{job.location}</span>
          <span className="">{job.time}</span>
        </p>
        <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
          <img src={LocIcon} alt="loc icon" className="w-4 h-4" />
          {job.type}
        </span>
        <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
          <img src={BagIcon} alt="bag icon" className="w-4 h-4" />
          {job.level}
        </span>
        <span className="text-gray-500 font-semibold text-xs flex gap-1 items-center">
          <img src={PaperIcon} alt="paper icon" className="w-4 h-4" />
          {job.resumNum > 100 ? 100 + "+" : job.resumNum}
        </span>
      </div>

      {/* details */}
      <div>
        {/* carts */}
        <div className="flex items-center gap-8">
          <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
            <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
              <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                  Active Job Openings
                </p>
              </div>
              <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                <p className="text-gray-700 text-lg font-semibold">
                  150,000 – 250,000
                  <span className="text-xs ml-3 text-gray-500">/ month</span>
                </p>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
            <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
              <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                  Date Posted
                </p>
              </div>
              <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                <p className="text-gray-700 text-lg font-semibold">
                  Jan 30, 2025
                </p>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
            <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
              <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                  Status
                </p>
              </div>
              <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                <p className="text-gray-700 text-lg font-semibold">Open</p>
              </div>
            </div>
          </div>
        </div>

        {/* description */}
        <div className="mt-6 flex flex-col gap-10">
          <div className="flex flex-col gap-2">
            <h2 className="text-gray-700 font-semibold text-lg">
              Job Description
            </h2>
            <p className="text-gray-500 font-medium text-[16px]">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur.
            </p>
          </div>
          <div className="flex flex-col gap-7">
            <div className="flex gap-6 items-center">
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                    <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                      Job Responsibilities
                    </p>
                  </div>
                  <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                    <ul className="text-gray-700  list-inside list-disc">
                      <li className="">
                        Write clean, scalable code in JavaScript and React
                      </li>
                      <li>
                        Collaborate with cross-functional teams to design
                        applications
                      </li>
                      <li>Optimize components for maximum performance</li>
                      <li>Troubleshoot and debug software issues</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                    <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                      Required Skills & Qualifications
                    </p>
                  </div>
                  <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                    <ul className="text-gray-700  list-inside list-disc">
                      <li className="">
                        Bachelor's degree in Computer Science or related field
                      </li>
                      <li>3+ years of experience in frontend development</li>
                      <li>Proficiency in JavaScript, React.js, and CSS</li>
                      <li>Strong problem-solving skills</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="w-full">
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                    <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                      Preferred Skills
                    </p>
                  </div>
                  <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                    <ul className="text-gray-700  list-inside list-disc">
                      <li className="">Experience with Redux and TypeScript</li>
                      <li>Knowledge of RESTful APIs and GraphQL</li>
                      <li>Familiarity with Agile development methodologies</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/*  */}

            <div className="flex flex-col gap-5">
              <h2 className="text-gray-700 text-lg font-semibold">
                Compensation & Benefits
              </h2>
              <div>
                <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                    <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                      <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                        Preferred Skills
                      </p>
                    </div>
                    <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                      <ul className="text-gray-700  list-inside list-disc">
                        <li className="">Health & dental insurance</li>
                        <li>Paid time off (20 days per year)</li>
                        <li>Work-from-home flexibility</li>
                        <li>Gym membership reimbursement</li>
                        <li>Learning & development budget</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showFeedback && (
        <CandidateFeedbackModal
          companyName={job?.company || ""}
          jobTitle={job?.position || ""}
          onClose={() => setShowFeedback(false)}
        />
      )}
    </div>
  );
}

export default CandidateAppliedDetails;